<template>
  <div class="RouterFooter">
    <div class="box">
      <div class="box-left">
        <div class="img" @click="back('/')">
          <div><img src="../assets/shj/logindi.png" alt="" /></div>
        </div>
        <!-- <div class="content1" v-if="lan=='en'">
             <img src="@/assets/icon1.png" alt="">

           </div> -->
        <!-- <div class="content1">
          <img src="@/assets/image/容器1.png" alt="" />
           <div
            style="
              width: 2px;
              height: 26px;
              background-color: #fff;
              margin-right: 10px;
            "
          ></div>

          在线客服
        </div> -->
        <div class="content2">
          <!-- <img src="@/assets/image/容器 23.png" alt="" /> -->
          <!-- <div
            style="
              width: 2px !important;
              height: 26px;
              background-color: #fff;
              margin-right: 10px;
            "
          ></div> -->
          <div style="width: 99%;margin-bottom: 20px;">
            <p v-if="!language">地址：中国上海市宝山区牡丹江路1900号17幢A2-1</p>
            <p v-if="language">address:A2-1, Building 17, No. 1900, Mudanjiang Road, Baoshan District, Shanghai, China</p>

            <!-- <p>400-817-1181</p>   -->
          </div>
        </div>
        <div class="content1" style="display: flex;margin-top: 20px;">
          <!-- <img
            src="@/assets/image/容器 23.png"
            alt=""
            style="margin-right: 8px"
          /> -->
          <span v-if="!language">邮箱：salessupport@shine-hydrogen.com</span>
          <span v-if="language">mailbox：salessupport@shine-hydrogen.com</span>
        </div>
        <div class="content1" style="display: flex"></div>
      </div>
      <!-- <div class="box-centent">
        <div
          class="item"
          v-for="(menu, index) in menuList"
          :key="index"
          :class="n == index + 2 ? 'activee' : ''"
        >
          <h5
            @click="
              backItem('/WineCulture?type=' + menu.id, menu.id, index + 2)
            "
          >
            {{ menu.name }}
          </h5>
          <ul>
            <li
              v-for="(item, idx) in menu.children"
              :key="idx"
              @click="
                backChildrenNew(
                  '/WineCulture?type=' + menu.id + '&id=' + item.id,
                  item.id,
                  index + 2
                )
              "
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div> -->
       <div class="router" v-if="language == false">
          <router-link to="/"> 首页 </router-link>
          <router-link to="/CompanyProfile"> 公司介绍 </router-link>
          <router-link to="/Newtechnology?id=96"> 核心技术与服务</router-link>
          <router-link to="/NewProductCenter"> 产品中心 </router-link>
          <router-link to="/NewsCenter"> 新闻中心 </router-link>
          <router-link to="/ContactUs"> 联系我们 </router-link>
        </div>
        <div class="router" v-if="language == true">
           <router-link to="/"> Home Page </router-link>
           <router-link to="/CompanyProfile"> Company Introduction </router-link>
           <router-link to="/Newtechnology?id=96"> Core Technologies And Services</router-link>
           <router-link to="/NewProductCenter"> Product Center </router-link>
           <router-link to="/NewsCenter"> News Center </router-link>
           <router-link to="/ContactUs"> Contact Us </router-link>
         </div>
      <div class="box-right">
        <div class="img-box">
          <div class="er-img">
            <div>
              <img src="../assets/shj/erweima.jpg" alt="" />
            </div>
          </div>
          <!-- <div class="er-img">
            <div>
              <img src="" alt="" />
            </div>
          </div> -->
          <div class="img-title" style="display: flex">
            <!-- <div>官方微信公众号</div> -->
            <!-- <div>官方微信公众号</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="Footer">
		<div style="display: flex;align-items: center;">
			<div class="ICP" @click="GoICP()" v-if="language == false">
			 © 山海氢(上海)新能源科技有限公司
			</div>
			<div class="ICP" @click="GoICP()" v-if="language == true">
			 Shanhai Hydrogen (Shanghai) New Energy Technology Co., Ltd
			</div>
		</div>
      <div style="display: flex;align-items: center;">
		  <img src="../assets/image/gongan-T.png" alt="" />
		  <div class="ICP">{{!language?'沪ICP备2024083314号-1':'Shanghai ICP No. 2024083314-1'}}</div>
	  </div>

      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lan: String,
    n: Number,
    menuList: Array,
  },
  data() {
    return {
      showswiper: false,
      showswiper1: false,
      detail: "",
      list: [],
      token: 0,
      language:false,
    };
  },
  mounted() {
    this.language = localStorage.getItem("language") == 'English' ? true : false;
    console.log(this.language,"底部")
    this.token = localStorage.getItem("token");
    this.seo();
    // Vue.filter("removeGoodsItems", function (menuList) {
    //   return menuList.filter(function (item) {
    //     // 返回name不为"商品"的元素
    //     return item.name !== "商品" && item.name !== "营业网点" && item.name !== "信息公示";
    //   });
    // });
  },
  watch: {
    menuList() {
      this.list = this.menuList.filter(
        (item) =>
          (item.name != "商品" &&
            item.name != "营业网点" &&
            item.name != "信息公示") ||
          !item.children
      );
    },
  },
  methods: {
    callPhone(phoneNumber) {
      this.$refs.tels.href = `tel://` + phoneNumber;
      this.$refs.tels.click();
    },

    seo() {
      this.$http.post("/index/seo/list", {}).then((res) => {
        if (res.data.code == 0) {
          this.detail = res.data.data;
          console.log(res.data.data);
        }
      });
    },
    backItem(i, id, idx) {
      this.n = idx;
      if (!this.token && id == 5) {
        this.$router.push("/Login");
      } else {
        this.$router.push(i);
      }
      this.drawer = false;
    },
    backChildrenNew(i, id, idx) {
      this.n = idx;
      if (
        (!this.token && id == 42) ||
        (!this.token && id == 43) ||
        (!this.token && id == 44) ||
        (!this.token && id == 45)
      ) {
        this.$router.push("/Login");
      } else {
        this.$router.push(i);
      }
      this.drawer = false;
    },
    back1() {
      this.showswiper = true;
    },
    back2() {
      this.showswiper1 = true;
    },
    back(i, idx) {
      this.n = idx;
      this.$router.push(i);
    },
    GoICP() {
      window.open("https://beian.miit.gov.cn/");
    },
    verifyLogin() {
      // let check = sessionStorage.getItem('token')
      // console.log(check)
      // return check
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: white !important;
  text-decoration: none;
  display: block;

}
.router{
  display: flex;
  justify-content: space-between;
  width: 65%;
  flex-wrap: wrap;
   @media (max-width: 800px) {
    width: 100%;
    display: none;
  }
  @media (max-width: 1440px) {
    // width: 80%;
    // margin: 0 auto;
  }
}

.router-link-active {
  color: white;

  font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular !important;
  font-weight: normal;
  font-size: 16px;
  color: white;
  transition: color 0.8s !important;
}

.RouterFooter {
  width: 100%;
  // height: 400px;
  margin: 0 auto;
  // background: #333;

  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(13, 59, 91, 1) ;
  background-image: url("../assets/shj/footer-bottom.png") ;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;

  // &::after{
  //   content: '';
  //   position: absolute;
  //   width: 100%;
  //   height: 100%;
  //   left: 0;
  //   top: 0;
  //   background-image: url("../assets/shj/footer-bottom.png") ;
  // }
  @media (max-width: 300px) {
    padding: 50px 0;
  }
  .box {
    max-width: 1400px;
    width: 100%;
    // color: white;
    color: white;
    margin: 62px 334px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // height: 333px;
    @media (max-width: 1366px) {
      width: 950px;
    }
    @media (max-width: 1200px) {
      width: 100%;
    }
    @media (max-width: 950px) {
      width: 700px;
    }
    @media (max-width: 800px) {
      width: 350px;
      margin: 20px 334px 0;
    }
    @media (max-width: 500px) {
      width: 90%;
    }
    @media (max-width: 300px) {
      width: 85%;
      margin: 0;
    }

    .box-left {
      width: 300px;
      // height: 185px;
      @media (max-width: 1200px) {
        margin: 0 auto;
      }
      @media (max-width: 920px) {
        margin: 0 auto;
      }
      @media (max-width: 800px) {
        margin: 0 auto;
        width: 300px;
      }
      @media (max-width: 800px) {
        margin: 0 auto;
        // width: 100%;
      }
      .img:hover img {
        transform: translateY(-10px);
      }
      .img {
        width: 200px;
        height: 60px;
        cursor: pointer;
        img {
          transition: transform 0.5s ease;
          max-width: 100%;
        }
      }
      .content1:hover img {
        transform: translateY(-6px);
      }
      .content1 {
        display: flex;
        height: 28px;
        line-height: 24px;
        margin-top: 10px;
        font-size: 14px;
        cursor: pointer;
        @media (max-width: 300px) {
          margin-top: 30px;
        }
        font-family: Source Han Sans SC-ExtraLight, Source Han Sans SC !important;
        img {
          width: 28px;
          height: 28px;
          margin-right: 10px;
          transition: transform 0.5s ease;
          max-width: 100%;
        }
      }
      .content2:hover img {
        transform: translateY(-6px);
      }
      .content2 {
        display: -webkit-box;
        // width: 182px;
        height: 28px;
        line-height: 24px;
        font-weight: 400;
        margin-top: 10px;
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN !important;
        cursor: pointer;
        @media (max-width: 300px) {
          margin-top: 30px;
        }
        img {
          width: 28px;
          height: 28px;
          margin-right: 10px;
          transition: transform 0.5s ease;
          max-width: 100%;
          // @media (max-width: 1199px) {
          //   width: 20px;
          //   height: 20px;
          //   margin-top: 5px;
          // }
        }
      }
      .content2 p {
        word-break: break-all;
        margin: 0;
        font-size: 14px;
        display: flex;
        flex-wrap: wrap;
        // white-space: nowrap; /* 防止文本换行 */
        // overflow: hidden; /* 隐藏溢出的内容 */
        // text-overflow: ellipsis;
      }
      .content2 p:nth-of-type(2) {
        // display: flex;
        width: 160px;
        height: 20px;
        line-height: 14px;
        font-weight: 400;
        margin-top: 7px;
        font-size: 20px !important;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN-Bold !important;
        font-weight: normal;
      }
    }
    .box-centent {
      // width: 650px;
      margin: 0 90px 0 0;
      @media (max-width: 1366px) {
        // width: 600px;
        margin: 0;
        display: flex;
        flex-wrap: wrap;
      }
      @media (max-width: 1200px) {
        width: 600px;
        margin-right: auto;
        display: flex;
        flex-wrap: wrap;
      }
      @media (max-width: 920px) {
        margin: 0 auto;
      }
      @media (max-width: 800px) {
        display: none;
      }
      .item {
        // width: 75px;
        width: 85px;
        float: left;
        margin-left: 40px;
        // opacity: 0.6;
        // color: #fff;
        color: black;
        font-size: 14px;

        @media (max-width: 1200px) {
          margin-left: 30px;
        }

        h5:hover {
          font-weight: bold;
        }
        h5 {
          font-family: Microsoft YaHei, Microsoft YaHei !important;
          font-weight: 400;
          font-size: 14px;
          // color: #ffffff;
          color: white;
          line-height: 17px;
          cursor: pointer;
          transition: font-weight 0.5s;
        }
      }
      .item:first-child {
        margin-left: 0;
      }
      .item li:hover {
        color: #fff;
        // opacity: 1;
      }
      .item li {
        font-family: Microsoft YaHei, Microsoft YaHei !important;
        list-style: none;
        margin: 10px 0;
        padding: 0;
        color: rgb(164, 164, 164);
        // opacity: 0.6;
        cursor: pointer;
        transition: color 0.5s;
      }
      .item ul {
        margin: 0;
        padding: 0;
      }
    }
    .box-right {
      display: flex;
      // align-items: flex-end;
      width: 120px;
      // height: 285px;

      @media (max-width: 1440px) {
        // margin: 30px auto;
        height: 140px;
        width: 100%;
        text-align: center;
        margin-top: 20px;
      }
      @media (max-width: 500px) {
        // margin: 30px auto;
        width: 120px;
        margin: 10px auto;
      }
      .img-box {
        width: 100%;
        // display: flex;
        // justify-content: center;

        height: 138px;
        @media (max-width: 300px) {
          height: 115px;
          justify-content: center;
        }
        .er-img:hover img {
          transform: translateY(-6px);
        }
        .er-img {
          width: 119px;
          margin: 0 auto;
          // height: 200px;
          // margin-right: 55px;
          cursor: pointer;
          @media (max-width: 300px) {
            // margin-right: 10px;
          }
          img {
            width: 119px !important;
            height: 119px !important;
            transition: transform 0.5s ease;
            max-width: 100%;
            @media (max-width: 300px) {
              width: 100px;
              height: 100px;
            }
          }
        }
        .img-title {
          width: 100%;
          height: 16px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN-Medium !important;
          font-weight: normal;
          font-size: 16px;
          color: #ffffff;
          line-height: 14px;
          justify-content: center;
          cursor: pointer;
          @media (max-width: 500px) {
            width: 100%;
            margin: 0 auto;
            flex-wrap: wrap;
            font-size: 13px;
            justify-content: center;
          }
        }
      }

      // .img-title div:first-child {
      //   // margin-right: 20px;
      // }
      // .img-title div:last-child {
      //   // margin-left: 5px;
      //   @media (max-width: 300px) {
      //     margin-left: 0;
      //   }
      // }
      .content1:hover img {
        transform: translateY(-6px);
      }
      .content1 {
        margin-top: 19px;
        @media (max-width: 1199px) {
          margin-top: 10px;
        }
        // justify-content: center;
        text-align: center;
        cursor: pointer;
        img {
          transition: transform 0.5s ease;
          max-width: 100%;
          width: 35px;
          height: 35px;
        }
        span {
          text-align: center;
          @media (max-width: 800px) {
            width: 100%;
          }
        }
      }
    }
  }
  .line {
    width: 100%;
    // height: 1px;
    // margin-top: 10px;
    // margin: 5px 0 21px;
    // display: flex;
    background:none;
    justify-content: center;
  }
  .Footer {
    // width: 650px;
    height: 10px;
    display: flex;
	justify-content: center;
    @media (max-width: 800px) {
      width: 350px;
      height: 60px;
      flex-wrap: wrap;
    }
    @media (max-width: 500px) {
      width: 80%;
      // height: 60px;
      flex-wrap: wrap;
    }
    @media (max-width: 300px) {
      width: 100%;
      margin: 0 auto;
      // height: 60px;
      flex-wrap: wrap;
    }

    margin-bottom: 27px;
	
    img {
      width: 20px;
      height: 20px;
      margin-left: 16px;
      margin-right: 8px;
      cursor: pointer;
    }

    .ICP {
      font-family: SourceHanSansCN-Light, SourceHanSansCN-Light !important;
      font-size: 14px;
      color: white;
      // opacity: 0.7;
      cursor: pointer;
      transition: color 0.5s ease;
      text-align: center;
      @media (max-width: 800px) {
        margin: 0 auto;
      }
      @media (max-width: 300px) {
        text-align: center;
      }
    }
    .ICP:last-child {
      margin: 0;
    }
    .ICP:hover {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RouterFooter.vue